module.exports = __webpack_public_path__ + "static/p4ktldr-zoom-90c42b6afa2944dd39658bb214018af6.jpg";